import { render, staticRenderFns } from "./update-province.vue?vue&type=template&id=4e855234"
import script from "./update-province.vue?vue&type=script&lang=js"
export * from "./update-province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports